import { render, staticRenderFns } from "./ProductAdd.vue?vue&type=template&id=74617153"
import script from "./ProductAdd.vue?vue&type=script&lang=js"
export * from "./ProductAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports